import {Field, ErrorMessage, getIn} from 'formik'
import {Form as BSForm} from 'react-bootstrap'
import CustomSelect from './Custom'

function AdvancedSelect({
  name,
  options = [{name: 'provide options'}],
  optionValue = 'name',
  optionLabel = 'name',
  label,
  onChange,
  isMulti = false,
  className = 'mb-9',
  disabled = false,
  size = 'md',
  required = false,
  ErrorFeedback,
  validityClass,
  fontSize,
  keyProp = '',
  ...props
}) {
  const onChangeHandler = (selected, action, setFieldValue) => {
    if (keyProp) {
      const value = isMulti
        ? selected.map((item) => ({[keyProp]: item[optionValue]}))
        : selected
        ? {[keyProp]: selected[optionValue]}
        : ''
      setFieldValue(name, value)
    } else if (onChange) {
      if (action.action === 'clear') {
        onChange(isMulti ? [] : {}, action)
      } else {
        onChange(selected, action)
      }
    } else {
      const value = isMulti
        ? selected.map((obj) => obj[optionValue])
        : selected
        ? selected[optionValue]
        : ''
      setFieldValue(name, value)
    }
  }

  return (
    <BSForm.Group className={className} controlId={name}>
      <Field name={name}>
        {({form: {errors, touched, values, setFieldValue, setFieldTouched}}) => (
          <>
            {label && (
              <BSForm.Label className="fs-6 fw-bold">
                {label || name || 'Provide Label'}
                {required && (
                  <span
                    className={`small 
                    ${
                      isMulti
                        ? validityClass(getIn(errors, name), values[name][0], getIn(touched, name))
                        : validityClass(
                            getIn(errors, name),
                            getIn(values, name),
                            getIn(touched, name)
                          )
                    }
                    
                `}
                  >
                    *
                  </span>
                )}
              </BSForm.Label>
            )}

            <CustomSelect
              options={options}
              optionValue={optionValue}
              optionLabel={optionLabel}
              onChange={(selected, action) => onChangeHandler(selected, action, setFieldValue)}
              isMulti={isMulti}
              disabled={disabled}
              size={size}
              onBlur={() => {
                setFieldTouched(name, true)
              }}
              name={name}
              {...props}
            />
          </>
        )}
      </Field>
      <ErrorMessage name={name} component={ErrorFeedback} />
    </BSForm.Group>
  )
}
export default AdvancedSelect
